import React from 'react'
import {
  TopicInaccessibleGuard,
  TopicIndexNotReadyGuard,
  UnexpectedServiceErrorGuard
} from '../../share/guards'
import DomainsWidgetEmptyResultGuard from './DomainsWidgetEmptyResultGuard'
import { GuardProps } from '../types'

const DomainsWidgetDataGuards = ({ widgetId, children }: GuardProps): React.ReactElement => (
  <TopicInaccessibleGuard widgetId={widgetId}>
    <UnexpectedServiceErrorGuard widgetId={widgetId}>
      <TopicIndexNotReadyGuard widgetId={widgetId}>
        <DomainsWidgetEmptyResultGuard widgetId={widgetId}>
          {children}
        </DomainsWidgetEmptyResultGuard>
      </TopicIndexNotReadyGuard>
    </UnexpectedServiceErrorGuard>
  </TopicInaccessibleGuard>
)

export default DomainsWidgetDataGuards
